/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：VaJI
 */

"use strict"

/* harmony export (binding) */
export { zh_TW }
var zh_TW = {
  "work/project_title": "我的作品"
}

/***/
